import styled from 'styled-components';

export const StyledWrapper = styled.div`
  & .leaflet-container {
    box-sizing: border-box;
    width: 100%;
    height: 600px;
    border: 1px solid #ccc;
  }
  @media only screen and (max-width: 1920px) {
    & .leaflet-container {
      height: 550px;
    }
  }
  @media only screen and (max-width: 960px) {
    & .leaflet-container {
      height: 500px;
    }
  }
  @media only screen and (max-width: 600px) {
    & .leaflet-container {
      height: 450px;
    }
  }
  & .leaflet-control-attribution {
    display: none;
  }
`;
